/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Room_Sub_StationInputs */



/**
* | output |
* | --- |
* | "Boiler room/Substation" |
*
* @param {Boiler_Room_Sub_StationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_room_sub_station = /** @type {((inputs?: Boiler_Room_Sub_StationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Room_Sub_StationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Boiler room/Substation")
	return /** @type {LocalizedString} */ ("Chaufferie/Sous-station")
});